import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTemplateSchema } from './shapes';

export const getPlanTemplate = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/plan-template',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: PlanTemplateSchema }),
});
